import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Config } from 'final-form';
import { Location } from 'history';

import { Link, Text } from '@nord/ui';

import LazyImage from '../../../../atoms/LazyImage';
import TwoColView from '../../../../templates/TwoColView';
import loginImgLowRes from '../../../assets/img/Log-in.png';
import loginImg from '../../../assets/img/Log-in.svg';
import Form, { ILoginFormValues } from '../../organisms/LoginForm';

export interface IProps {
  isSubmitting?: boolean;
  onSubmit: Config<ILoginFormValues>['onSubmit'];
  forgotPasswordLink: Partial<Location>;
  organization?: string;
  onBackButtonClick?: () => void;
  leftImage?: string;
  leftImageLowRes?: string;
  rememberMe?: boolean;
  children?: React.ReactNode;
}

const LoginForm: FC<IProps> = ({
  rememberMe,
  isSubmitting,
  onSubmit,
  onBackButtonClick,
  forgotPasswordLink,
  organization,
  leftImage = loginImg,
  leftImageLowRes = !leftImage ? loginImgLowRes : undefined,
  children,
}) => (
  <TwoColView
    leftPanel={<LazyImage src={leftImage} preview={leftImageLowRes} alt="Login" />}
    backButton={onBackButtonClick ? { onClick: onBackButtonClick } : false}
  >
    <div className="md:mr-5">
      <Text className="mb-4 text-black font-bold" variant="h6" id="LoginFormHeadingText">
        Log in{organization && ` to ${organization}`}
      </Text>
      <Form onSubmit={onSubmit} isSubmitting={isSubmitting} rememberMe={rememberMe} />
      <Text variant="body2" className="font-medium pb-3">
        <Link
          data-testid="login-forgot-password"
          component={RouterLink}
          colorClassName="text-blue"
          to={forgotPasswordLink}
        >
          Forgot password?
        </Link>
      </Text>
      {children}
    </div>
  </TwoColView>
);

export default LoginForm;
